import React from "react";
import {Box, TextField} from "@mui/material";
import CopyAdornment from "crqlar-react-common/dist/components/CopyAdornment";

interface Props {
    label: string;
    value: string;
    copyable?: boolean;
    flex?: number | string
}

export const ReadOnlyField: React.FC<Props> = ({
                                                   label,
                                                   value,
                                                   copyable = false,
                                                   flex = 1
                                               }) => {
    return (
        <Box flex={flex}>
            <TextField
                fullWidth
                label={label}
                value={value}
                InputProps={{
                    readOnly: true,
                    sx: {fontSize: '16px'},
                    endAdornment: copyable ? (
                        <Box sx={{mr: '0.2em'}}>
                            <CopyAdornment value={value || ''}/>
                        </Box>
                    ) : undefined,
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: '3.5em',
                        alignItems: 'center',
                        paddingLeft: '0.5em',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23) !important',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23) !important',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23) !important',
                            borderWidth: "1px !important",
                        },
                        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23) !important',
                        },
                        '&.Mui-active .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23) !important',
                            borderWidth: "1px !important",
                        },
                    },
                    '& .MuiOutlinedInput-input': {
                        fontSize: '16px',
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                }}
            />
        </Box>
    );
};

export default ReadOnlyField;